import {defineStore} from "pinia"
import {$auth} from "@/plugins/auth"

export const useQuotaStore = defineStore("quota", {
  state: () => ({
    total: 0 as number,
    available: 0 as number,
    loading: false as boolean,
  }),
  getters: {
    raw(state): number {
      if (state.total <= 0) {
        return 0
      }

      const percentage = ((state.total - state.available) / state.total) * 100

      return Math.min(100, Math.max(0, percentage))
    },
    display(): string {
      const percentage = Number(this.raw)

      if (percentage > 0 && percentage < 0.1) {
        return '< 0.1'
      }

      return percentage.toFixed(1)
    },
  },
  actions: {
    set() {
      const user = $auth.user as any

      this.total = Number(user?.account?.quota ?? 0)

      this.available = Number(user?.account?.available_quota ?? 0)
    },
    async refresh() {
      this.loading = true

      await $auth.loadUser(true)

      this.set()

      this.loading = false
    },
  }
})
